import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import { getOnNotificationFromWindowOrDefault, setWindowConfiguration } from '../FlowWebProvider/FlowWebInternal';
import { Notification } from './Notification';
import { StyledTransitionGroup } from './NotificationHost.styled';
function createNotificationCreator(type, defaultTimeout) {
  /**
   *	@param content The content to be displayed by the notification.
   *  @param options - Includes timeout and action options. See {@link NotificationOptions}.
   */
  return function (content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var optionsWithDefaults = _objectSpread({
      timeout: defaultTimeout
    }, options);
    var notification = {
      content: content,
      type: type,
      timeout: optionsWithDefaults.timeout,
      action: optionsWithDefaults.action,
      id: Math.random().toString(16).slice(2)
    };
    var sharedOnNotification = getOnNotificationFromWindowOrDefault();
    return sharedOnNotification(notification);
  };
}
export var notifyError = createNotificationCreator('Error', 0);
export var notifyInfo = createNotificationCreator('Info', 0);
export var notifySuccess = createNotificationCreator('Success', 2000);
export var notifyWarning = createNotificationCreator('Warning', 0);
export var NotificationHost = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationHost, _React$Component);
  var _super = _createSuper(NotificationHost);
  function NotificationHost() {
    var _this;
    _classCallCheck(this, NotificationHost);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      notifications: [],
      canHandleNotifications: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleNotification", function (notification) {
      _this.setState(function (state) {
        return {
          notifications: [].concat(_toConsumableArray(state.notifications), [notification])
        };
      });
      return function () {
        return _this.handleRemoveNotification(notification);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handleRemoveNotification", function (notification) {
      _this.setState(function (state) {
        var index = state.notifications.findIndex(function (n) {
          return n.id === notification.id;
        });
        if (index !== -1) {
          return _objectSpread(_objectSpread({}, state), {}, {
            notifications: [].concat(_toConsumableArray(state.notifications.slice(0, index)), _toConsumableArray(state.notifications.slice(index + 1)))
          });
        }
      });
    });
    return _this;
  }
  _createClass(NotificationHost, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state.canHandleNotifications) {
        return null;
      }
      return /*#__PURE__*/React.createElement(StyledTransitionGroup, {
        style: this.props.location
      }, this.state.notifications.map(function (n) {
        return /*#__PURE__*/React.createElement(Notification, {
          key: n.id,
          notification: n,
          onRemoveNotification: _this2.handleRemoveNotification
        });
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      setWindowConfiguration(this.props.instanceSymbol, {
        onNotification: this.handleNotification
      });
      if (getOnNotificationFromWindowOrDefault() === this.handleNotification) {
        this.setState({
          canHandleNotifications: true
        });
      }
    }
  }]);
  return NotificationHost;
}(React.Component);